module.exports = __webpack_public_path__ + "img/ic_checkbox_rounded-active.41c16847.svg";